/*
 * Mae Jum standard-blog index filter — client-side, real-time filtering (TRC-011).
 * Clean port of assets/blog-filter.js for the standard (non-recipe) blog. Pairs
 * with snippets/blog-filter-sidebar-articles.liquid, rendered by
 * sections/blog-template.liquid when filter_mode == 'blog'.
 *
 * Only ONE index filter JS loads per page: recipe pages load blog-filter.js,
 * standard-blog pages load this file — so there is never a collision even though
 * both bind the same #mj-* ids and the same .m-blog-sidebar sticky behaviour.
 *
 * No dependencies. No localStorage. No URL params / history. No page reload.
 * Match data is read from the card data-* attributes emitted by
 * snippets/article-card.liquid, so this behaves identically on any store.
 *
 * Card data attributes used here:
 *   data-t        title, lowercased
 *   data-author   article author, lowercased
 *   data-tags     raw article tags, comma-joined (Quick Search haystack only)
 *   data-category category tags ("category:" prefix stripped), comma-joined (Category facet)
 *   data-excerpt  hover-overlay text
 *
 * Group logic (see snippets/blog-filter-sidebar-articles.liquid data-f values):
 *   author    (vs data-author)   : OR within group
 *   category  (vs data-category) : OR within group
 *   Quick Search            : substring vs title + author + tags
 *   Between groups          : AND
 */
(function () {
  'use strict';

  function splitLower(raw) {
    if (!raw) return [];
    return raw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }

  // Parsed card property backing each facet group (used by cardMatches/updateCounts).
  var GROUP_PROP = { author: 'authorArr', category: 'categoryArr' };

  // Fill each card's hover overlay with its excerpt; cards with no excerpt get a
  // marker class so they receive the hover lift but no dark overlay. Runs once.
  function initHoverOverlays() {
    document.querySelectorAll('.m-article-card').forEach(function (card) {
      var excerpt = card.dataset.excerpt || '';
      if (excerpt.trim() === '') {
        card.classList.add('mj-card-no-excerpt');
      } else {
        var textEl = card.querySelector('.mj-card-overlay__text');
        if (textEl) textEl.textContent = excerpt;
      }
    });
  }

  function init() {
    var grid = document.getElementById('mj-article-grid');
    if (!grid) return;

    var resultsCount = document.getElementById('mj-results-count');
    var filterRoot = document.getElementById('mj-filter');

    var cardEls = Array.prototype.slice.call(grid.querySelectorAll('.m-article-card'));
    var cards = cardEls.map(function (el) {
      var author = (el.getAttribute('data-author') || '').trim().toLowerCase();
      var tags = splitLower(el.getAttribute('data-tags'));
      var categoryArr = splitLower(el.getAttribute('data-category'));
      var t = (el.getAttribute('data-t') || '').toLowerCase();
      return {
        el: el,
        t: t,
        authorArr: author ? [author] : [],
        tags: tags,
        categoryArr: categoryArr,
        // Combined haystack for Quick Search (title + author + tags).
        hay: (t + ' ' + author + ' ' + tags.join(' '))
      };
    });

    function setCounts(n) {
      if (resultsCount) resultsCount.textContent = n + (n === 1 ? ' article' : ' articles');
    }

    // No filter sidebar (e.g. default blog with show_sidebar off) — just show total.
    if (!filterRoot) { setCounts(cards.length); return; }

    initHoverOverlays();

    var searchInput = document.getElementById('mj-filter-search');
    var resetBtn = document.getElementById('mj-filter-reset');
    var checkboxes = Array.prototype.slice.call(filterRoot.querySelectorAll('.mj-filter-cb'));

    function anyIn(sel, arr) {
      for (var i = 0; i < sel.length; i++) if (arr.indexOf(sel[i]) !== -1) return true;
      return false;
    }

    // Group checked boxes → { groupKey: [valueLower, ...] }
    function activeGroups() {
      var groups = {};
      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var g = cb.getAttribute('data-f');
        var v = (cb.getAttribute('data-v') || '').trim().toLowerCase();
        (groups[g] = groups[g] || []).push(v);
      });
      return groups;
    }

    function cardMatches(card, groups) {
      if (groups.author && !anyIn(groups.author, card.authorArr)) return false;
      if (groups.category && !anyIn(groups.category, card.categoryArr)) return false;
      return true;
    }

    // ---- core apply --------------------------------------------------------
    function apply() {
      var search = (searchInput ? searchInput.value : '').trim().toLowerCase();
      var groups = activeGroups();
      var visible = 0;

      var anyActive = search !== '' || Object.keys(groups).length > 0;
      var resultsLabel = document.getElementById('mj-results-label');
      if (resultsLabel) resultsLabel.textContent = anyActive ? 'Search Results' : 'All Articles';

      cards.forEach(function (card) {
        var show = true;
        if (search) show = card.hay.indexOf(search) !== -1;
        if (show) show = cardMatches(card, groups);
        card.el.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      setCounts(visible);
      updateBadges(groups);
      updateCounts();
    }

    // ---- per-section count badges ------------------------------------------
    function updateBadges(groups) {
      var badges = filterRoot.querySelectorAll('.mj-filter-section__badge');
      Array.prototype.forEach.call(badges, function (badge) {
        var key = badge.getAttribute('data-badge');
        var n = groups[key] ? groups[key].length : 0;
        badge.textContent = n;
        if (n > 0) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', '');
      });
    }

    // ---- per-checkbox live counts + dead-end grey-out ----------------------
    function updateCounts() {
      var visible = cards.filter(function (c) { return c.el.style.display !== 'none'; });
      checkboxes.forEach(function (cb) {
        var g = cb.getAttribute('data-f');
        var v = (cb.getAttribute('data-v') || '').trim().toLowerCase();
        var prop = GROUP_PROP[g];
        var n = prop ? visible.filter(function (c) { return c[prop].indexOf(v) !== -1; }).length : 0;
        var label = cb.closest('.mj-filter-option');
        var countEl = label ? label.querySelector('.mj-facet-count') : null;
        if (countEl) countEl.textContent = '(' + n + ')';
        if (n === 0 && !cb.checked) {
          if (label) label.classList.add('mj-facet-disabled');
          cb.disabled = true;
        } else {
          if (label) label.classList.remove('mj-facet-disabled');
          cb.disabled = false;
        }
      });
    }

    // ---- listeners ---------------------------------------------------------
    if (searchInput) searchInput.addEventListener('input', apply);
    checkboxes.forEach(function (cb) { cb.addEventListener('change', apply); });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        if (searchInput) searchInput.value = '';
        apply();
      });
    }

    // Collapsible sections — toggle aria-expanded (chevron rotation is CSS-driven).
    var headers = filterRoot.querySelectorAll('.mj-filter-section__header');
    Array.prototype.forEach.call(headers, function (header) {
      header.addEventListener('click', function () {
        var section = header.closest('.mj-filter-section');
        if (!section) return;
        var open = section.getAttribute('aria-expanded') !== 'false';
        section.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    // Initial paint (full set; no filters active yet).
    apply();

    // ---- TRC-012 Steps 4/5: mobile filter drawer -----------------------------
    // Open/close the off-canvas drawer, keep the mobile-bar badge in sync, and
    // hide the fixed bar over the footer. Drawer chrome lives OUTSIDE #mj-filter
    // (in the section), so query via document — not filterRoot. All drawer
    // interactions are mobile-only (guard on innerWidth < 768).
    var mjDrawer   = document.querySelector('.m-blog-sidebar');
    var mjOverlay  = document.getElementById('mj-filter-overlay');
    var mjOpenBtn  = document.getElementById('mj-filter-open-btn');
    var mjCloseBtn = document.getElementById('mj-filter-close-btn');
    var mjBar      = document.querySelector('.mj-filter-mobile-bar');
    var mjBadge    = document.getElementById('mj-filter-badge');

    function mjOpenDrawer() {
      if (window.innerWidth >= 768) return;
      if (mjDrawer) mjDrawer.classList.add('mj-drawer-open');
      if (mjOverlay) mjOverlay.classList.add('mj-overlay-active');
      if (mjOpenBtn) mjOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function mjCloseDrawer() {
      if (window.innerWidth >= 768) return;
      if (mjDrawer) mjDrawer.classList.remove('mj-drawer-open');
      if (mjOverlay) mjOverlay.classList.remove('mj-overlay-active');
      if (mjOpenBtn) mjOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (mjOpenBtn) mjOpenBtn.addEventListener('click', mjOpenDrawer);
    if (mjCloseBtn) mjCloseBtn.addEventListener('click', mjCloseDrawer);
    if (mjOverlay) mjOverlay.addEventListener('click', mjCloseDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      if (window.innerWidth >= 768) return;
      if (mjDrawer && mjDrawer.classList.contains('mj-drawer-open')) mjCloseDrawer();
    });

    // Active-filter count on the mobile bar. Delegated change listener so the
    // runtime-injected facet checkboxes are covered too.
    function updateBadge() {
      if (!mjBadge) return;
      var n = filterRoot.querySelectorAll('.mj-filter-cb:checked').length;
      if (n > 0) {
        mjBadge.textContent = n;
        mjBadge.style.display = 'flex';
      } else {
        mjBadge.style.display = 'none';
      }
    }
    filterRoot.addEventListener('change', updateBadge);
    updateBadge();

    // Hide the fixed Filters bar once the footer scrolls into view.
    var mjFooter = document.querySelector('.m-footer');
    if (mjFooter && mjBar && window.innerWidth < 768 && 'IntersectionObserver' in window) {
      var mjBarObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          mjBar.style.display = entry.isIntersecting ? 'none' : '';
        });
      });
      mjBarObserver.observe(mjFooter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------
 * JS sticky sidebar — identical implementation to assets/blog-filter.js.
 * CSS position:sticky does NOT engage in this theme at runtime, so the
 * sidebar is fixed to the viewport once its placeholder scrolls past the
 * header offset, parked at the container bottom, and released on scroll-up
 * / resize. A placeholder preserves the sidebar's footprint. Desktop only
 * (window.innerWidth < 768 returns early); offset = 40px; bottom boundary.
 * ------------------------------------------------------------------ */
(function() {
  var sidebar = document.querySelector('.m-blog-sidebar');
  if (!sidebar) return;

  var placeholder = document.createElement('div');
  var isFixed = false;
  var triggerY = 0;

  function initPlaceholder() {
    placeholder.style.width  = sidebar.offsetWidth + 'px';
    placeholder.style.height = sidebar.offsetHeight + 'px';
    placeholder.style.display = 'none';
    sidebar.parentNode.insertBefore(placeholder, sidebar);
    var rect = sidebar.getBoundingClientRect();
    triggerY = rect.top + window.scrollY;
  }

  function onScroll() {
    // TRC-012 Fix 2: drawer mode owns mobile — never engage the desktop fix here.
    if (window.innerWidth < 768) return;
    var offset = 40;
    var placeholderTop = triggerY - offset;

    var container = sidebar.closest('.m-row')
                    || sidebar.parentNode;
    var containerBottom = container.getBoundingClientRect().bottom
                          + window.scrollY;
    var sidebarBottom = window.scrollY + offset
                        + sidebar.offsetHeight;

    if (!isFixed && window.scrollY > placeholderTop
        && sidebarBottom < containerBottom) {
      // switch to fixed
      sidebar.style.position = 'fixed';
      sidebar.style.top = offset + 'px';
      sidebar.style.bottom = '';
      sidebar.style.width = placeholder.style.width;
      sidebar.style.maxHeight = 'calc(100vh - ' + offset + 'px - 20px)';
      sidebar.style.overflowY = 'auto';
      placeholder.style.display = 'block';
      isFixed = true;
    } else if (isFixed && sidebarBottom >= containerBottom) {
      // park at bottom
      sidebar.style.position = 'absolute';
      sidebar.style.top = '';
      sidebar.style.bottom = '0';
      sidebar.style.width = placeholder.style.width;
      sidebar.style.maxHeight = '';
      sidebar.style.overflowY = '';
      placeholder.style.display = 'block';
      isFixed = false;
    } else if (isFixed && window.scrollY <= placeholderTop) {
      // release at top
      sidebar.style.position = '';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
      sidebar.style.width = '';
      sidebar.style.maxHeight = '';
      sidebar.style.overflowY = '';
      placeholder.style.display = 'none';
      isFixed = false;
    }
  }

  function onResize() {
    // TRC-012 Fix 2: below 768 the sidebar is a CSS drawer, so fully unwind any
    // desktop sticky state left over from a wider load — clear the inline styles,
    // hide the placeholder, and bail before re-arming onScroll (which would re-fix).
    if (window.innerWidth < 768) {
      sidebar.style.position = '';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
      sidebar.style.width = '';
      sidebar.style.maxHeight = '';
      sidebar.style.overflowY = '';
      placeholder.style.display = 'none';
      isFixed = false;
      return;
    }
    if (isFixed) {
      sidebar.style.position = '';
      sidebar.style.top      = '';
      sidebar.style.width    = '';
      sidebar.style.maxHeight = '';
      sidebar.style.overflowY = '';
      placeholder.style.display = 'none';
      isFixed = false;
    }
    var rect = sidebar.getBoundingClientRect();
    triggerY = rect.top + window.scrollY;
    placeholder.style.width = sidebar.offsetWidth + 'px';
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Desktop only — mobile gets a separate filter drawer in a future session.
    if (window.innerWidth < 768) return;
    initPlaceholder();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    onScroll();
  });
})();
